import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"
import Avatar from "./avatar.js"
import About from "./about.js"

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background: transparent;
  width: 100%;
  padding-top: 3vh;
`

const OuterContainer = styled.div`
  display: block;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 90vh;
  background: transparent;
`

const Description = styled.p`
  padding: 0;
  margin-bottom: 1rem;
  font-size: 1.4rem;
`

const NameHeader = styled.h1`
  font-family: "Lato";
  font-size: 3.5rem;
  margin-bottom: 0;
  user-select: none;
`

const LandingBio = () => (
  <StaticQuery
    query={graphql`
      query LandingSiteTitleQuery {
        site {
          siteMetadata {
            title
            subtitle
          }
        }
      }
    `}
    render={data => (
      <OuterContainer>
        <Container>
          <Avatar/>
          <NameHeader>{data.site.siteMetadata.title}</NameHeader>
          {//<Description>{data.site.siteMetadata.subtitle}</Description>
    }
          <About/>
        </Container>
      </OuterContainer>
    )}
  />
)

NameHeader.propTypes = {
  siteTitle: PropTypes.string,
  subtitle: PropTypes.string,
}

NameHeader.defaultProps = {
  siteTitle: ``,
  subtitle: ``,
}

export default LandingBio
